interface WalletIconProps {
  width?: number;
  height?: number;
  /** Pass '#ffffff' for active (white) state, anything else for inactive (grey) */
  color?: string;
}

export default function WalletIcon({
  width = 17,
  height = 17,
  color = 'rgba(0,0,0,0.50)',
}: WalletIconProps) {
  // The SVG asset is white, so we invert to black/grey for inactive state
  // When active (white text), no filter needed
  const isWhite = color === '#ffffff';
  const filterStyle = isWhite
    ? 'none' // already white
    : 'brightness(0) opacity(0.5)'; // make it grey

  return (
    <img
      src="/icons/wallet-nav.svg"
      alt="wallet"
      style={{ width, height, filter: filterStyle, flexShrink: 0 }}
    />
  );
}
